import { MDBBtn, MDBIcon } from "mdbreact"
import React from 'react'
import BootstrapTable from "react-bootstrap-table-next"
import cellEditFactory, { Type } from "react-bootstrap-table2-editor"
import Select from 'react-select'
import { Card, CardBody, Col, Container, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import ModalSolicitud from '../../components/ModalPersonalizado/ModalSolicitud';

var colaboradores = [];
var departamentos = [];
var tipos_solicitudes = [];
const { SearchBar, ClearSearchButton } = Search;
const columns = [
    {
        text: "Código",
        dataField: "id",
        editable: false,
        headerStyle: (column, colIndex) => {
            return { width: '5%' }; 
        }
    },
    {
        text: "Titulo",
        dataField: "titulo",
        editable: false,
        headerStyle: (column, colIndex) => {
            return { width: '14%' }; 
        }
    },
    {
        text: "Fecha creación",
        dataField: "fecha_creacion_str",
        editable: false,
        headerStyle: (column, colIndex) => {
            return { width: '7%' }; 
        }
    },    
    {
        text: "Programado",
        dataField: "fecha_programada",
        editor: {
            //type: Type.DATE,
            type: 'DATE',
            getOptions: setTimeout(
                () => new Date(),
                100),
            dateFormat: 'YYYY-MM-DD'
        },
        formatter: (cell) => {
            let dateObj = cell;
            if (typeof cell !== 'object' && cell !== '') {
                dateObj = new Date(cell);
                return `${('0' + dateObj.getUTCDate()).slice(-2)}-${('0' + (dateObj.getUTCMonth() + 1)).slice(-2)}-${dateObj.getUTCFullYear()}`;
            }
            return '';
        },
        hidden: window.innerWidth < 768,
        headerStyle: (column, colIndex) => {
            return { width: '5%' }; 
        }
    },
    {
        text: "Fecha Fin",
        dataField: "fecha_fin",
        editor: {
            //type: Type.DATE
            type: 'DATE',
            getOptions: setTimeout(
                () => new Date(),
                100),
            dateFormat: 'YYYY-MM-DD'
        },
        formatter: (cell) => {
            let dateObj = cell;
            if (typeof cell !== 'object' && cell !== '') {
                dateObj = new Date(cell);
                return `${('0' + dateObj.getUTCDate()).slice(-2)}-${('0' + (dateObj.getUTCMonth() + 1)).slice(-2)}-${dateObj.getUTCFullYear()}`;
            }
            return '';
        },
        hidden: window.innerWidth < 768,
        headerStyle: (column, colIndex) => {
            return { width: '5%' }; 
        }
    },
    {
        text: "Asignado a",
        dataField: "colaborador",
        editor: {
            type: Type.SELECT,
            getOptions: (setOptions, { row, column }) => {
                let colaboradores_depart = colaboradores.filter(({ id_departamento }) => id_departamento === row.solicitar_a);
                setTimeout(() => setOptions(colaboradores_depart), 100);
            }
        },
        formatter: (cell) => {
            let colaborador = colaboradores.find(colaborador => {
                return colaborador.value == cell;
            });

            return colaborador !== undefined && colaborador !== null ? colaborador.label : '';
        },
        style: {
            backgroundColor: 'rgba(80, 165, 241, 0.03)'
        },
        headerStyle: (column, colIndex) => {
            return { width: '15%' }; 
        }
    },
    {
        text: "Ubicación",
        dataField: "lugar_ubicacion_nombre",
        editable: false,
        headerStyle: (column, colIndex) => {
            return { width: '9%' }; 
        }
    },
    /*{
        text: "Depar",
        dataField: "asignado_a_nombre",
        editable: false,
        formatter: (cell) => {
            return (window.innerWidth < 768) ? cell.substring(0, 3) : cell;
        }
    },*/
    {
        text: "Departamento",
        dataField: "solicitar_a",
        editor: {
            type: Type.SELECT,
            getOptions: (setOptions) => {
                setTimeout(() => setOptions(departamentos), 100);
            }
        },
        formatter: (cell) => {
            let solicitar_a = departamentos.find(solicitar_a => {
                return solicitar_a.value == cell;
            });
            return solicitar_a !== undefined && solicitar_a !== null ? solicitar_a.label : '';
        },
        style: {
            backgroundColor: 'rgba(80, 165, 241, 0.03)'
        },
        headerStyle: (column, colIndex) => {
            return { width: '15%' }; 
        }
    },
    {
        text: "Tipo",
        dataField: "tipo_solicitud",
        editor: {
            type: Type.SELECT,
            getOptions: (setOptions, { row, column }) => {
                let tipo_solicitud_depart = tipos_solicitudes.filter(({ departamento_area }) => departamento_area === row.solicitar_a);
                setTimeout(() => setOptions(tipo_solicitud_depart), 100);
            }
        },
        formatter: (cell) => {
            let tipo_solicitud = tipos_solicitudes.find(tipo_solicitud => {
                return tipo_solicitud.value == cell;
            });

            return tipo_solicitud !== undefined && tipo_solicitud !== null ? tipo_solicitud.label : '';
        },
        style: {
            backgroundColor: 'rgba(80, 165, 241, 0.03)'
        },
        headerStyle: (column, colIndex) => {
            return { width: '7%' }; 
        }
    },
    {
        text: "Prioridad",
        dataField: "prioridad",
        editor: {
            type: Type.SELECT,
            options: [
                { value: 0, label: 'Baja' },
                { value: 1, label: 'Media' },
                { value: 2, label: 'Alta' },
                { value: 3, label: 'Emergencia' },
            ]
        },
        formatter: (cell) => {
            if (cell == 0) {
                return 'Baja'
            } else if (cell == 1) {
                return 'Media'
            } else if (cell == 2) {
                return 'Alta'
            } else if (cell == 3) {
                return 'Emergencia'
            } 

            return '';
        },
        headerStyle: (column, colIndex) => {
            return { width: '7%' }; 
        }
    },
    {
        text: "Estado",
        dataField: "estado",
        editor: {
            type: Type.SELECT,
            options: [
                { value: 0, label: 'No Asignado' },
                { value: 1, label: 'Asignado' },
                { value: 2, label: 'Planificado' }/*,
                { value: 7, label: 'Autorizado' },
                { value: 3, label: 'Concluido' }*/
            ]
        },
        formatter: (cell) => {
            if (cell == 0) {
                return 'No Asignado'
            } else if (cell == 1) {
                return 'Asignado'
            } else if (cell == 2) {
                return 'Planificado'
            } /*else if (cell == 7) {
                return 'Autorizado'
            } else if (cell == 3) {
                return 'Concluido'
            } */

            return '';
        },
        style: {
            backgroundColor: 'rgba(80, 165, 241, 0.03)'
        },
        headerStyle: (column, colIndex) => {
            return { width: '7%' }; 
        }
    },
    {
        text: " ",
        dataField: "accion",
        editable: false,
        headerStyle: (column, colIndex) => {
            return { width: '4%' }; 
        }
    }
];

class TaskQueue {
    constructor() {
      this.queue = [];
      this.executing = false;
    }
  
    addTask(task) {
      this.queue.push(task);
      this.runNext();
    }
  
    runNext() {
      if (this.executing || this.queue.length === 0) {
        return;
      }
  
      this.executing = true;
      const task = this.queue.shift();
      task().then(() => {
        this.executing = false;
        this.runNext();
      });
    }
}

export default class SolicitudAsignar extends React.Component {

    constructor(props) {
        super(props)

        this.apiRest = new ApiRest(props);

        this.solicitud = 'ASIGNAR_PLANIFICAR';
        this.titulo = 'Asignar Planificar Solicitud';
        this.pathname = this.props.location.pathname
        switch (this.props.location.pathname) {
            case '/solicitudEmergencias':
                this.solicitud = 'ASIGNAR_EMERGENCIA';
                this.titulo = 'Asignar Emergencias';
                break;
        }
        this.state = {
            tabla: { columns: columns, rows: [] },
            tablaList: [],
            modalAbierto: false,
            mostrarSpinner: true,
            ubicaciones: [],
            departamentosAreas: [],
            tiposSolicitudes: [],
            lista: [],

            registro: {

            },

            filtros: {
                fechaMin: undefined,
                fechaFin: undefined,
                lugar_ubicacion: undefined,
                solicitar_a: undefined,
                tipo_solicitud: undefined,
                usuario: undefined,
                empresa: undefined,
                solicitud_id: undefined,
                paginaActual: 1,
                totalPaginas: 0,
            }
        }
        this.taskQueue = new TaskQueue();
    }

    componentDidMount() {
        this.cargarValoresFiltros();
        this.obtenerColaboradores();
        this.obtenerTiposSolicitudes();
        /*let filtros_anteriores = JSON.parse(localStorage.getItem("filtros_"+this.solicitud));
        if (filtros_anteriores) {  
            this.setState({ filtros: filtros_anteriores });
            this.setState({ mostrarSpinner: true });
            if ( this.solicitud == 'NUEVA'|| this.solicitud == 'CALIFICAR'|| this.solicitud == 'CONCLUIR' ) {
                filtros_anteriores.solicitud = this.solicitud;
                filtros_anteriores.usuario = this.apiRest.getLS('du').colaborador.id;                
                this.apiRest.put('/misSolicitudes', filtros_anteriores).then(respuesta => {
                    if (respuesta.exitoso) {                        
                        this.setState({ tablaList: this.agregarAccionesRegistro(respuesta.data) });
                        this.setState({ mostrarSpinner: false});
                    }
                });
            } else {
                filtros_anteriores.solicitud = this.solicitud;
                this.apiRest.post('/solicitudesFiltradas', filtros_anteriores).then(respuesta => {
                    if (respuesta.exitoso) {
                        this.setState({ tablaList: this.agregarAccionesRegistro(respuesta.data) });
                        this.obtenerTipoSolicitud(this.state.filtros.solicitar_a);
                        this.setState({ mostrarSpinner: false});
                    }
                });
            }*/
            //this.filtros = this.filtros_anteriores;
            /*this.setState(estadoAnterior => ({
                filtros: { ...estadoAnterior.filtros, ...filtros_anteriores }
            }));  */      
            /*this.apiRest.post('/busquedaFiltradaSolicitud', filtros_anteriores ).then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({ mostrarSpinner: false, tabla: this.agregarAccionesRegistro(respuesta.data) });
                    this.obtenerTipoSolicitud(this.state.filtros.solicitar_a);
                }
            });*/
        /*} else {*/
            
        /*}*/
        const{
            filtros
        } = this.state;
        setTimeout(() => this.Pagina(filtros), 1500);
    }

    Pagina = (filtros) => {
        if ( this.solicitud == 'NUEVA'|| this.solicitud == 'CALIFICAR'|| this.solicitud == 'CONCLUIR' ) {
            this.revisarMisSolicitudes();
        } else {
            this.buscar();
        }
    }

    formatoSelect = valores => valores.data.map(i => ({ value: i.id, label: i.nombre }));
    formatoSelectUbicacion = valores => valores.data.map(i => ({ value: i.id, label: i.ubicacion_texto }));
    formatoSolicitud = valores => valores.data.map(i => ({ value: i.id, label: i.id + '->' + i.titulo }));

    listaSolicitudes = (idDepartamento) => {
        if (idDepartamento) {
            let filtros = {};
            filtros = {
                departamento: idDepartamento.value,
                estado: [0]
            }

            if (this.solicitud == 'ASIGNAR_EMERGENCIA'){
                filtros['prioridad'] = [3]
            }

            this.apiRest.post('/solicitudNumero', filtros).then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({
                        lista: this.formatoSolicitud(respuesta)
                    })
                }
            });
        } else {
            this.setState({ lista: [] });
            this.limpiarCampo('solicitud_id');
        }
    }

    revisarMisSolicitudes = () => {
        const {
            filtros
        } = this.state

        filtros.solicitud = this.solicitud;
        filtros.usuario = this.apiRest.getLS('du').colaborador.id;
        filtros.user = this.apiRest.getLS('du');
        this.setState({ mostrarSpinner: true });
        this.apiRest.put('/misSolicitudes', filtros).then(respuesta => {
            if (respuesta.exitoso) {                
                this.setState({ tablaList: this.agregarAccionesRegistro2(respuesta.data.Lista) });
                this.setState({ mostrarSpinner: false });
            }
        });
    }

    limpiarCampo = (name) => {
        this.setState(estadoAnterior => ({
            filtros: { ...estadoAnterior.filtros, [name]: null }
        }));
    }

    limpiar = () => {
        //localStorage.removeItem("filtros_"+this.solicitud);
        
        this.setState({
            filtros: {
                fechaMin: '',
                fechaFin: '',
                lugar_ubicacion: '',
                solicitar_a: '',
                tipo_solicitud: '',                
                solicitud_id: '',
            },
            tabla: { columns: columns, rows: [] },
        });
    }

    cargarValoresFiltros = () => {

        this.apiRest.get('/colaboradorDepartamentoAreaAsociados').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ departamentosAreas: resultado.data });
                departamentos = [{ value: '', label: '' }].concat(resultado.data);
            }
        });
        this.apiRest.get('/ubicacion').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ ubicaciones: this.formatoSelectUbicacion(resultado) });
            }
        });
        /*if (this.apiRest.getRol()) {
            this.apiRest.get('/ubicacion').then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ ubicaciones: this.formatoSelectUbicacion(resultado) });
                }
            });
        } else {
            if (_valid(this.apiRest.getLS('idEmpresa'))) {
                this.apiRest.getUbicacion('/getUbicacion/').then(respuesta => {
                    if (respuesta.exitoso) {
                        this.setState({ ubicaciones: this.formatoSelectUbicacion(respuesta) });
                    }
                });
            }
        }*/
    }

    obtenerColaboradores() {
        this.apiRest.get('/colaboradorDepartamentoArea').then(resultado => {
            if (resultado.exitoso) {
                console.log(resultado.data);
                colaboradores = [{ value: '', label: '' }].concat(resultado.data);
            }
        });
    }

    obtenerTiposSolicitudes() {
        this.apiRest.get('/tipoSolicitud').then(resultado => {
            if (resultado.exitoso) {
                console.log(resultado.data);
                tipos_solicitudes = [{ value: '', label: '', departamento_area: '' }].concat(resultado.data);
            }
        });
    }

    obtenerTipoSolicitud(departamentoArea) {
        if (_valid(departamentoArea)) {
            this.apiRest.get('/tipoSolicitudPorDepartamentoArea/' + departamentoArea.value).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ tiposSolicitudes: this.formatoSelect(resultado) });
                }
            });
        } else {
            this.setState({ tiposSolicitudes: [] });
            this.limpiarCampo('tipo_solicitud');
        }
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            filtros: { ...estadoAnterior.filtros, [name]: value }
        }));
    }

    setDepartamentoArea = departamentoArea => {
        this.setState(estadoAnterior => ({
            filtros: { ...estadoAnterior.filtros, ['solicitar_a']: departamentoArea }
        }));

        this.obtenerTipoSolicitud(departamentoArea);
        this.listaSolicitudes(departamentoArea);
    }

    setTipoSolicitud = tipoSolicitud => {
        this.setState(estadoAnterior => ({
            filtros: { ...estadoAnterior.filtros, ['tipo_solicitud']: tipoSolicitud }
        }));
    }

    setUbicacion = ubicacion => {
        this.setState(estadoAnterior => ({
            filtros: { ...estadoAnterior.filtros, ['lugar_ubicacion']: ubicacion }
        }));
    }

    setSolicitud = solicitud => {
        this.setState(estadoAnterior => ({
            filtros: { ...estadoAnterior.filtros, ['solicitud_id']: solicitud }
        }));
    }

    agregarAccionesRegistro = rows => {
        rows.forEach(registro => [
            registro.titulo = (registro.titulo != "") ? registro.titulo : registro.descripcion.substring(0, 35), 
            registro.accion = this.botonesListado(registro)
        ]);
        return rows;
    };

    agregarAccionesRegistro2 = rows => {
        let datos = [];
        rows.forEach(registro => {
            if (_valid(registro)) {
                datos = this.agregarAccionesRegistro(registro);
            }
        });
        return datos;
    };

    botonesListado = (registro, indicador) => {
        return [
            (
                (registro.estado == 0) ?
                    <ModalSolicitud titulo="Asignar proyecto / colaborador" color="info" icon="fas fa-project-diagram" rol="asignar_proyecto"
                    idRegistro={registro.id} actualizarFila={this.actualizarFila}/>
                : ''
            )
        ]
    }

    buscar = () => {
        const {
            filtros
        } = this.state

        filtros.solicitud = this.solicitud;
        this.setState({ mostrarSpinner: true });
        
        this.apiRest.post('/solicitudesFiltradasPaginacion', filtros).then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ 
                    tablaList: this.agregarAccionesRegistro(respuesta.data.Lista), 
                    filtros: {...filtros, paginaActual: respuesta.data.paginaActual, totalPaginas: respuesta.data.totalPaginas}
                });
                this.obtenerTipoSolicitud(this.state.filtros.solicitar_a);
                this.setState({ mostrarSpinner: false });
            }
        });
    }

    filtrarBusqueda = () => {
        const {
            filtros
        } = this.state
        filtros.solicitud = this.solicitud;
        filtros.paginaActual = 1;
        filtros.totalPaginas = 0;        
        //localStorage.setItem("filtros_"+this.solicitud, JSON.stringify(filtros));

        if (this.validarFiltros()) {
            if ( this.solicitud == 'NUEVA'|| this.solicitud == 'CALIFICAR'|| this.solicitud == 'CONCLUIR' ) {
                this.revisarMisSolicitudes();
            } else {
                this.buscar();
            }
        }
    }

    validarFiltros = () => {
        const {
            filtros
        } = this.state

        if (_valid(filtros.fechaMin)) {
            if (_valid(filtros.fechaMin) && _valid(filtros.fechaFin)) {
                return true
            } else {
                toastr.error('Fecha no valida falta seleccionar Fecha Fin.');
                return false
            }
        }

        if (_valid(filtros.fechaFin)) {
            if (_valid(filtros.fechaMin) && _valid(filtros.fechaFin)) {
                return true
            } else {
                toastr.error('Fecha no valida falta seleccionar Fecha Inicio.');
                return false
            }
        }

        return true;
    }

    actualizarFila = (idRegistro) => {
        this.apiRest.getWithFiles('/solicitud/' + idRegistro).then(resultado => {
            if (resultado.exitoso) {                
                let newTodos;
                if(resultado.data.estado != 0){
                    newTodos = this.state.tablaList.filter(el => el.id != idRegistro)
                } else {
                    const indiceElemento = this.state.tablaList.findIndex(el => el.id == idRegistro);
                    newTodos = [...this.state.tablaList]
                    newTodos[indiceElemento] = {...resultado.data, accion: this.botonesListado(resultado.data)}
                }
                this.setState(estadoAnterior => ({
                    tablaList: newTodos
                }));
                console.log(this.state.tablaList)
            }
        });
    }

    verificarDepartamento = (filtros) => {
        if (_valid(filtros.solicitar_a)) {
            return true;
        } else {
            return false;

        }
    }

    verificacionFecha = (filtros) => {
        let fechaInicio = filtros.fechaMin;
        let fechaFin = filtros.fechaFin;
        if (_valid(fechaInicio)) {
            if (_valid(fechaInicio && fechaFin)) {
                return true;
            } else {
                return false;
            }
        } else if (_valid(fechaFin)) {
            if (_valid(fechaInicio && fechaFin)) {
                return true;
            } else {
                return false;
            }
        }
        return true;
    }

    actualizarCelda = (oldValue, newValue, row, column) => {

        let datos = {}
        if (column.dataField == 'fecha_programada') {
            datos = {
                ...row, fecha_programada: newValue
            }
        } else if (column.dataField == 'fecha_fin') {
            datos = {
                ...row, fecha_fin: newValue
            }
        } else if (column.dataField == 'colaborador') {
            //row.estado = 1;
            datos = {
                ...row, colaborador: newValue
            }
        } else if (column.dataField == 'solicitar_a') {
            const indiceElemento = this.state.tablaList.findIndex(el => el.id == row.id);
            let newTodos = [...this.state.tablaList]
            newTodos[indiceElemento] = {...row, solicitar_a: parseInt(newValue), tipo_solicitud: null, colaborador: null}
            
            this.setState(estadoAnterior => ({
                tablaList: newTodos
            }));
            
            datos = {
                ...row, solicitar_a: newValue, tipo_solicitud: null, colaborador: null
            }
        } else if (column.dataField == 'tipo_solicitud') {
            datos = {
                ...row, tipo_solicitud: newValue
            }
        } else if (column.dataField == 'prioridad') {
            datos = {
                ...row, prioridad: newValue
            }
        } else if (column.dataField == 'estado') {
            if((row.solicitar_a == null || row.colaborador == null || row.tipo_solicitud == null) && parseInt(newValue) != 0){
                row.estado = 0
                if(row.solicitar_a == null) toastr.info('Falta Departamento en el ticket '+row.id)
                else if(row.colaborador == null) toastr.info('Falta Colaborador en el ticket '+row.id)
                else if(row.tipo_solicitud == null) toastr.info('Falta Tipo de Solicitud en el ticket '+row.id)
            } else {
                datos = {
                    ...row, estado: newValue
                } 
                
                this.apiRest.put('/solicitudTablaEditable/' + row.id, datos).then(respuesta => {
                    if (respuesta.exitoso) {
                                           
                        this.taskQueue.addTask(() => this.guardarEnHistorial(datos));
                        this.taskQueue.addTask(() => this.asignarOdoo(row.id));
                        this.taskQueue.addTask(() => this.whatsappAsignarSolicitud(row.id));                        
                                           
                        this.actualizarFila(row.id);
                        toastr.success('Registro actualizado exitosamente!'); 
                        /*if (column.dataField == 'estado' && (newValue == 1 || newValue == 2)) {
                            this.apiRest.get('/enviarCorreoSolicitud/' + row.id).then(resultado => {
                                if (resultado.exitoso) {
                                    toastr.success('Correo enviado exitosamente!');
                                }
                            });
                        }*/
                    } else {
                        console.log('Ha ocurrido un error al modificar la solicitud '+ row.id);
                    }
                });
            }   
        } 
    }

    guardarEnHistorial = (registro) => {
        return new Promise((resolve, reject) => {
            const comentario = 'Asignado desde la tabla editable';
            if (_valid(comentario)) {
                const { estado, id } = registro;
                let datos = { comentario };
                if (estado !== undefined) {
                datos["estado"] = parseInt(estado);
                }
                if (id) {
                datos["solicitud"] = id;
                }
                this.apiRest.post('/historial', datos).then(resultado => {
                if (resultado.exitoso) {
                    console.log('Se guardo el historial.');
                    resolve();
                } else {
                    console.log('No se guardo comentario para el historial ' + id);
                    reject();
                }
                });
            } else {
                resolve();
            }
        });
    };

    enviarOdoo(id) {
        this.apiRest.get('/enviarOdooSolicitud/' + id).then(resultado => {
            if (resultado.exitoso) {
                console.log('Enviado a Odoo exitosamente!');
                this.asignarOdoo(id);
            } else {
                console.log('Ocurrió un error al crear el ticket en Odoo '+ id);
            }
        });
    }

    asignarOdoo = (id) => {
        return new Promise((resolve, reject) => {
            this.apiRest.get('/asignarOdooSolicitud/' + id).then(resultado => {
                if (resultado.exitoso) {
                    toastr.success('Se envió el ticket ', id, {
                        closeButton: true,
                    });
                    resolve();
                } else {
                    console.log('No se pudo asignar el ticket en Odoo ' + id);
                    reject();
                }
            });           
        });
    };

    whatsappAsignarSolicitud = (id) => {
        return new Promise((resolve, reject) => {
            this.apiRest.get('/whatsappAsignarSolicitud/' + id).then(resultado => {
                if (resultado.exitoso) {
                    console.log('Whatsapp enviado exitosamente!');
                    resolve();
                } else {
                    toastr.error('No se pudo enviar Whatsapp.', id, {
                        timeOut: 0, closeButton: true, extendedTimeOut: 0, tapToDismiss: false,
                    });
                    reject();
                }
            });
        });
    };

    nextPage = () => {
        const{
            filtros
        } = this.state
        if (filtros.paginaActual < filtros.totalPaginas) {
            filtros.paginaActual = filtros.paginaActual + 1;
            this.Pagina(filtros);
        }else{
            toastr.warning('No hay más registros')
        }
    }

    previousPage = () => {
        const{
            filtros
        } = this.state
        if (filtros.paginaActual > 1) {
            filtros.paginaActual = filtros.paginaActual - 1;
            this.Pagina(filtros);
        }else{
            //toastr.warning('No hay más registros')
        }
    }

    render() {
        const {
            mostrarSpinner,
            tablaList,
            modalAbierto,
            filtros,
            ubicaciones,
            departamentosAreas,
            tiposSolicitudes,
            lista
        } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Mesa de Servicio" breadcrumbItem={this.titulo} />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>                                        
                                        <Row>
                                            <Col lg={3} sm={6} xs={6}>
                                                <Label htmlFor="fechaMin" className="form-label">
                                                    Fecha Inicio
                                                </Label>
                                                <Input
                                                    name="fechaMin"
                                                    value={filtros.fechaMin}
                                                    onChange={this.actualizarValores}
                                                    type="date"
                                                />
                                            </Col>
                                            <Col lg={3} sm={6} xs={6}>
                                                <Label htmlFor="fechaFin" className="form-label">
                                                    Fecha Fin
                                                </Label>
                                                <Input
                                                    name="fechaFin"
                                                    value={filtros.fechaFin}
                                                    onChange={this.actualizarValores}
                                                    type="date"
                                                />
                                            </Col>
                                            <Col lg={3} sm={6} xs={6}>
                                                <Label htmlFor="solicitar_a" className="form-label">
                                                    Departamento / Área
                                                </Label>
                                                <Select
                                                    name="solicitar_a"
                                                    options={departamentosAreas}
                                                    value={filtros.solicitar_a}
                                                    onChange={this.setDepartamentoArea}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    placeholder="Seleccionar"
                                                    isClearable={true}
                                                    isSearchable={true}
                                                    noOptionsMessage={() => "No hay más opciones"}
                                                />
                                            </Col>
                                            <Col lg={3} sm={6} xs={6}>
                                                <Label htmlFor="tipo_solicitud" className="form-label">
                                                    Tipo de solicitud
                                                </Label>
                                                <Select
                                                    name="tipo_solicitud"
                                                    options={tiposSolicitudes}
                                                    value={filtros.tipo_solicitud}
                                                    onChange={this.setTipoSolicitud}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    placeholder="Seleccionar"
                                                    isClearable={true}
                                                    isSearchable={true}
                                                    noOptionsMessage={() => "No hay más opciones"}
                                                />
                                            </Col>
                                        </Row>
                                        <p />
                                        <Row>
                                            <Col lg={3} sm={6} xs={6}>
                                                <Label htmlFor="lugar_ubicacion" className="form-label">
                                                    Ubicaci&oacute;n
                                                </Label>
                                                <Select
                                                    name="lugar_ubicacion"
                                                    options={ubicaciones}
                                                    value={filtros.lugar_ubicacion}
                                                    onChange={this.setUbicacion}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    placeholder="Seleccionar"
                                                    isClearable={true}
                                                    isSearchable={true}
                                                    noOptionsMessage={() => "No hay más opciones"}
                                                />
                                            </Col>
                                            <Col lg={3} sm={6} xs={6}>
                                                <Label htmlFor="solicitud_id" className="form-label">
                                                    No. de solicitud
                                                </Label>
                                                <Select
                                                    name="solicitud_id"
                                                    options={lista}
                                                    value={filtros.solicitud_id}
                                                    onChange={this.setSolicitud}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    placeholder="Seleccionar"
                                                    isClearable={true}
                                                    isSearchable={true}
                                                    noOptionsMessage={() => "No hay más opciones"}
                                                />
                                            </Col>
                                        </Row>
                                        <p />
                                        <Row>
                                            <Col lg={12}>
                                                <MDBBtn className="waves-effect" color="success" onClick={this.filtrarBusqueda}>
                                                    <MDBIcon icon="fas fa-search" />{' '}
                                                    Buscar
                                                </MDBBtn>
                                                <MDBBtn className="waves-effect float-end" color="secondary" onClick={this.limpiar}>
                                                Borrar Filtros
                                                </MDBBtn>
                                            </Col>
                                        </Row>
                                        <p />                                        
                                        <Row>
                                            <Col lg={3} md={12} xs={12} style={{ display: "flex", justifyContent: "right" }}>
                                                <Label htmlFor="#" className="form-label">
                                                    {'Pagina No: ' + this.state.filtros.paginaActual + ' | Total de Paginás: ' + this.state.filtros.totalPaginas}
                                                </Label>
                                            </Col>
                                            <Col lg={3} md={6} xs={6} style={{ display: "flex", justifyContent: "center" }}>
                                                <MDBBtn className="waves-effect" color="primary" onClick={() => this.previousPage()}>
                                                    <MDBIcon icon="fas fa-angle-double-left" /> {' '}
                                                    Paginá Anterior
                                                </MDBBtn>
                                            </Col>
                                            <Col lg={3} md={6} xs={6} style={{ display: "flex", justifyContent: "center" }}>
                                                <MDBBtn className="waves-effect" color="primary" onClick={() => this.nextPage()}>
                                                    Paginá Siguiente
                                                    {' '}<MDBIcon icon="fas fa-angle-double-right" />
                                                </MDBBtn>
                                            </Col>                                            
                                            {
                                                mostrarSpinner &&
                                                <Col lg={3} md={12} xs={12} style={{ display: "flex", justifyContent: "left" }}>
                                                    <Spinner className="m-1" color="primary" />
                                                </Col>
                                            }                                            
                                        </Row>
                                        
                                        <div className="table-responsive">
                                            <ToolkitProvider
                                                keyField="id"
                                                data={tablaList}
                                                columns={columns}
                                                search
                                            >
                                                {
                                                    props => (
                                                        <div>
                                                            {
                                                                <SearchBar
                                                                {...props.searchProps}
                                                                className="custome-search-field"
                                                                delay={1000}
                                                                srText="Buscar"
                                                                />
                                                            }
                                                            <BootstrapTable
                                                                {...props.baseProps}
                                                                keyField="id"
                                                                //data={tablaList}
                                                                columns={columns}
                                                                cellEdit={cellEditFactory(
                                                                    {
                                                                        blurToSave: true,
                                                                        mode: 'click',
                                                                        beforeSaveCell: (() => { return false}),
                                                                        afterSaveCell: this.actualizarCelda
                                                                    }
                                                                )}
                                                                tabIndexCell
                                                            />
                                                        </div>
                                                    )
                                                }
                                            </ToolkitProvider>
                                        </div>
                                        <Row>
                                            <Col lg={3} md={12} xs={12} style={{ display: "flex", justifyContent: "right" }}>
                                                <Label htmlFor="#" className="form-label">
                                                    {'Pagina No: ' + this.state.filtros.paginaActual + ' | Total de Paginás: ' + this.state.filtros.totalPaginas}
                                                </Label>
                                            </Col>
                                            <Col lg={3} md={6} xs={6} style={{ display: "flex", justifyContent: "center" }}>
                                                <MDBBtn className="waves-effect" color="primary" onClick={() => this.previousPage()}>
                                                    <MDBIcon icon="fas fa-angle-double-left" /> {' '}
                                                    Paginá Anterior
                                                </MDBBtn>
                                            </Col>
                                            <Col lg={3} md={6} xs={6} style={{ display: "flex", justifyContent: "center" }}>
                                                <MDBBtn className="waves-effect" color="primary" onClick={() => this.nextPage()}>
                                                    Paginá Siguiente
                                                    {' '}<MDBIcon icon="fas fa-angle-double-right" />
                                                </MDBBtn>
                                            </Col>                                            
                                            {
                                                mostrarSpinner &&
                                                <Col lg={3} md={12} xs={12} style={{ display: "flex", justifyContent: "left" }}>
                                                    <Spinner className="m-1" color="primary" />
                                                </Col>
                                            }                                            
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}